export const getAllOffers = (state) => state.offers;

const offersReducer = (statePart = [], action) => {
  switch (action.type) {
    default:
      return statePart;
  }
};

export default offersReducer;
